export function show() {
  this._.$stage.style.visibility = 'visible';
  return this;
}
